/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_AssetInputs */

const id_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const ms_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset`)
};

const da_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const de_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const en_us2_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const es_es2_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const es_mx2_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const fil_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const fr_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const it_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const hu_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const nl_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const no_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiendel`)
};

const pl_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const pt_br2_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const pt_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const ro_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const fi_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssi`)
};

const sv_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgång`)
};

const vi_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const tr_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const cs_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const bg_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const ru_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассет`)
};

const uk_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const ar_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أصل`)
};

const hi_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट`)
};

const th_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซท`)
};

const ja_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット`)
};

const zh_cn2_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

const zh_hant1_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源`)
};

const ko_home_pulse_badge_asset = /** @type {(inputs: Home_Pulse_Badge_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋`)
};

/**
* | output |
* | --- |
* | "Asset" |
*
* @param {Home_Pulse_Badge_AssetInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_asset = /** @type {((inputs?: Home_Pulse_Badge_AssetInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_AssetInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_asset(inputs)
	if (locale === "ms") return ms_home_pulse_badge_asset(inputs)
	if (locale === "da") return da_home_pulse_badge_asset(inputs)
	if (locale === "de") return de_home_pulse_badge_asset(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_asset(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_asset(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_asset(inputs)
	if (locale === "fil") return fil_home_pulse_badge_asset(inputs)
	if (locale === "fr") return fr_home_pulse_badge_asset(inputs)
	if (locale === "it") return it_home_pulse_badge_asset(inputs)
	if (locale === "hu") return hu_home_pulse_badge_asset(inputs)
	if (locale === "nl") return nl_home_pulse_badge_asset(inputs)
	if (locale === "no") return no_home_pulse_badge_asset(inputs)
	if (locale === "pl") return pl_home_pulse_badge_asset(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_asset(inputs)
	if (locale === "pt") return pt_home_pulse_badge_asset(inputs)
	if (locale === "ro") return ro_home_pulse_badge_asset(inputs)
	if (locale === "fi") return fi_home_pulse_badge_asset(inputs)
	if (locale === "sv") return sv_home_pulse_badge_asset(inputs)
	if (locale === "vi") return vi_home_pulse_badge_asset(inputs)
	if (locale === "tr") return tr_home_pulse_badge_asset(inputs)
	if (locale === "cs") return cs_home_pulse_badge_asset(inputs)
	if (locale === "bg") return bg_home_pulse_badge_asset(inputs)
	if (locale === "ru") return ru_home_pulse_badge_asset(inputs)
	if (locale === "uk") return uk_home_pulse_badge_asset(inputs)
	if (locale === "ar") return ar_home_pulse_badge_asset(inputs)
	if (locale === "hi") return hi_home_pulse_badge_asset(inputs)
	if (locale === "th") return th_home_pulse_badge_asset(inputs)
	if (locale === "ja") return ja_home_pulse_badge_asset(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_asset(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_asset(inputs)
	return ko_home_pulse_badge_asset(inputs)
});
export { home_pulse_badge_asset as "home.pulse.badge.asset" }